/* global window, document, navigator */
(function () {
    const root = document.documentElement;
    const NAV_OPEN_CLASS = 'is-drawer-open';
    const GHOST_PAYWALL_SELECTORS = [
        '.kg-card[data-kg-card-paywall]',
        '.gh-paywall-card',
        '.gh-post-upgrade-cta'
    ].join(', ');
    const PATREON_MEMBERSHIP_URL = 'https://patreon.com/ethanhuang13/membership';

    const getSystemPref = () => (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');

    const applyTheme = (value) => {
        const mode = value === 'dark' ? 'dark' : 'light';
        root.dataset.theme = mode;
    };

    const initTheme = () => {
        applyTheme(getSystemPref());

        const systemWatcher = window.matchMedia('(prefers-color-scheme: dark)');
        const syncSystem = () => {
            applyTheme(getSystemPref());
        };

        systemWatcher.addEventListener('change', syncSystem);
    };

    const initNavigation = () => {
        const navToggle = document.querySelector('[data-nav-toggle]');
        const navPanel = document.querySelector('[data-nav-panel]');
        const closeButtons = document.querySelectorAll('[data-nav-close]');
        const focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
        let lastFocusedElement = null;

        const isNavOpen = () => document.body.classList.contains(NAV_OPEN_CLASS);

        const getFocusableItems = () => {
            if (!navPanel) {
                return [];
            }

            return Array.from(navPanel.querySelectorAll(focusableSelector))
                .filter((node) => node.getClientRects().length > 0);
        };

        const closeNav = ({restoreFocus = true} = {}) => {
            document.body.classList.remove(NAV_OPEN_CLASS);
            if (navToggle) {
                navToggle.setAttribute('aria-expanded', 'false');
            }

            if (navPanel) {
                navPanel.setAttribute('aria-hidden', 'true');
                navPanel.inert = true;
            }

            if (restoreFocus && lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
                lastFocusedElement.focus();
            }
        };

        const openNav = () => {
            if (!navPanel || !navToggle) {
                return;
            }

            lastFocusedElement = document.activeElement;
            document.body.classList.add(NAV_OPEN_CLASS);
            navToggle.setAttribute('aria-expanded', 'true');
            navPanel.setAttribute('aria-hidden', 'false');
            navPanel.inert = false;

            window.requestAnimationFrame(() => {
                const firstItem = getFocusableItems()[0];
                if (firstItem && isNavOpen()) {
                    firstItem.focus();
                }
            });
        };

        if (navToggle) {
            navToggle.addEventListener('click', () => {
                if (isNavOpen()) {
                    closeNav();
                } else {
                    openNav();
                }
            });
        }

        closeButtons.forEach((button) => {
            button.addEventListener('click', closeNav);
        });

        if (navPanel) {
            navPanel.addEventListener('click', (event) => {
                if (event.target === navPanel || event.target.closest('a')) {
                    closeNav({restoreFocus: false});
                }
            });
        }

        window.addEventListener('resize', () => {
            if (window.innerWidth >= 980 && isNavOpen()) {
                closeNav({restoreFocus: false});
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && isNavOpen()) {
                closeNav();
            }

            if (event.key !== 'Tab' || !isNavOpen()) {
                return;
            }

            const items = getFocusableItems();
            if (!items.length) {
                return;
            }

            const firstItem = items[0];
            const lastItem = items[items.length - 1];

            if (event.shiftKey && document.activeElement === firstItem) {
                event.preventDefault();
                lastItem.focus();
            } else if (!event.shiftKey && document.activeElement === lastItem) {
                event.preventDefault();
                firstItem.focus();
            }
        });
    };

    const removeNativeCodeCopy = (container) => {
        container.querySelectorAll('button:not(.code-copy), figcaption').forEach((node) => {
            const text = node.textContent.trim().toLowerCase();
            const looksLikeCopyControl = text === 'copy' || text === 'copied' || node.matches('[class*="copy"], [data-kg-copy]');

            if (looksLikeCopyControl) {
                node.remove();
            }
        });
    };

    const fallbackCopy = (text) => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.top = '-1000px';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        const didCopy = document.execCommand('copy');
        textarea.remove();

        if (!didCopy) {
            throw new Error('Copy failed');
        }
    };

    const copyToClipboard = (text) => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            return navigator.clipboard.writeText(text).catch(() => fallbackCopy(text));
        }

        return Promise.resolve().then(() => fallbackCopy(text));
    };

    const initCopyButtons = () => {
        const blocks = document.querySelectorAll('.gh-content pre');
        blocks.forEach((block) => {
            if (block.parentNode && block.parentNode.classList.contains('code-block')) {
                removeNativeCodeCopy(block.parentNode);
                return;
            }

            const sourceParent = block.parentNode;
            const wrapper = document.createElement('div');
            wrapper.className = 'code-block';

            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'code-copy';
            button.innerText = '複製';

            button.addEventListener('click', () => {
                const text = block.textContent;
                copyToClipboard(text).then(() => {
                    button.innerText = '已複製';
                    button.classList.add('is-active');
                    window.setTimeout(() => {
                        button.innerText = '複製';
                        button.classList.remove('is-active');
                    }, 1800);
                }).catch(() => {
                    button.innerText = '複製失敗';
                    window.setTimeout(() => {
                        button.innerText = '複製';
                    }, 1800);
                });
            });

            removeNativeCodeCopy(sourceParent);
            sourceParent.insertBefore(wrapper, block);
            wrapper.appendChild(block);
            removeNativeCodeCopy(wrapper);
            wrapper.appendChild(button);
        });
    };

    const initGhostPaywallCleanup = () => {
        document.querySelectorAll(GHOST_PAYWALL_SELECTORS).forEach((node) => {
            node.remove();
        });
    };

    const initPortalSignupRedirect = () => {
        const redirectSignup = () => {
            if (window.location.hash.startsWith('#/portal/signup')) {
                window.location.href = PATREON_MEMBERSHIP_URL;
            }
        };

        const redirectLink = (event) => {
            event.preventDefault();
            event.stopPropagation();
            window.location.href = PATREON_MEMBERSHIP_URL;
        };

        const rewritePortalSignupLinks = () => {
            const portalRoot = document.getElementById('ghost-portal-root');
            if (!portalRoot) {
                return;
            }

            portalRoot.querySelectorAll('iframe').forEach((frame) => {
                let frameDocument = null;

                try {
                    frameDocument = frame.contentDocument || (frame.contentWindow && frame.contentWindow.document);
                } catch (error) {
                    frameDocument = null;
                }

                if (!frameDocument) {
                    return;
                }

                frameDocument.querySelectorAll('a, button').forEach((node) => {
                    if (node.dataset.codexPatreonSignup === 'true') {
                        return;
                    }

                    if (node.textContent.trim() !== '註冊') {
                        return;
                    }

                    node.dataset.codexPatreonSignup = 'true';

                    if (node.tagName === 'A') {
                        node.href = PATREON_MEMBERSHIP_URL;
                        node.target = '_top';
                        node.rel = 'noreferrer';
                    }

                    node.addEventListener('click', redirectLink, true);
                });
            });
        };

        window.addEventListener('hashchange', redirectSignup);

        const portalObserver = new MutationObserver(rewritePortalSignupLinks);
        portalObserver.observe(document.body, {
            childList: true,
            subtree: true
        });

        redirectSignup();
        rewritePortalSignupLinks();
        window.setInterval(rewritePortalSignupLinks, 500);
    };

    const initBriefCards = () => {
        const normalize = (text) => text.replace(/\s+/g, ' ').trim();
        const CTA_SELECTORS = [
            GHOST_PAYWALL_SELECTORS,
            '.kg-signup-card',
            '.kg-button-card',
            '[data-members-cta]',
            '[data-portal]'
        ].join(', ');

        document.querySelectorAll('[data-brief-source]').forEach((source) => {
            const card = source.closest('.brief-item');
            const target = card ? card.querySelector('[data-brief-target]') : null;

            if (!target) {
                return;
            }

            const clone = source.cloneNode(true);
            clone.querySelectorAll(CTA_SELECTORS).forEach((node) => node.remove());

            const fallback = normalize(target.dataset.briefFallback || '');
            const content = normalize(clone.textContent || '');
            const raw = fallback || content;
            const truncated = raw.length > 80 ? raw.slice(0, 80).trimEnd() + '…' : raw;
            target.textContent = truncated;
        });
    };

    const initWeeklyTitles = () => {
        document.querySelectorAll('[data-weekly-title]').forEach((title) => {
            const issueTitle = title.textContent
                .replace(/^📰\s*/, '')
                .replace(/^Apple\s*開發者週報\s*/, '')
                .trim();

            title.textContent = issueTitle ? `📰 ${issueTitle}` : '';
        });
    };

    const initWeeklyArticleTitles = () => {
        document.querySelectorAll('[data-weekly-article-title]').forEach((title) => {
            const normalized = title.textContent.trim();
            const match = normalized.match(/^((?:📰\s*)?Apple\s*開發者週報)\s*(#.+)$/);

            if (!match) {
                return;
            }

            title.textContent = '';

            const series = document.createElement('span');
            series.className = 'article-title__series';
            series.textContent = `${match[1].trim().startsWith('📰') ? '📰' : ''}Apple 開發者週報`;

            const issue = document.createElement('span');
            issue.className = 'article-title__issue';
            issue.textContent = match[2].trim();

            title.appendChild(series);
            title.appendChild(issue);
        });
    };

    document.addEventListener('DOMContentLoaded', () => {
        initTheme();
        initNavigation();
        initCopyButtons();
        initGhostPaywallCleanup();
        initPortalSignupRedirect();
        initBriefCards();
        initWeeklyTitles();
        initWeeklyArticleTitles();
    });
}());
